<template>
    <div
        class="fixed top-0 left-0 z-30 w-screen h-screen bg-black bg-opacity-70 flex justify-center items-center cursor-pointer"
        title="Click to close"
        @click="$emit('close')"
    >
        <span class="fixed z-30 top-6 right-8 text-white text-5xl font-bold">&times;</span>

        <div v-if="modalImageContainer" class="flex justify-center items-center bg-white p-4 lg:p-12 max-w-19/20 lg:max-w-4/5 max-h-19/20 lg:max-h-4/5 rounded-md">
            <img :src="modalImageUrl" class="object-cover" />
        </div>
        <img v-else :src="modalImageUrl" class="object-cover max-w-19/20 lg:max-w-4/5 max-h-19/20 lg:max-h-4/5" />
    </div>
</template>

<script>
export default {
    props: [
        'modalImage',
        'modalImageContainer',
        'modalImageUrl',
    ],
}
</script>